import type { ProductPlanListDTO } from '../software.types';

export class ProductPlanListModel {
  private readonly _dto: ProductPlanListDTO;

  constructor(dto: ProductPlanListDTO) {
    this._dto = dto;
  }

  get originDTO(): ProductPlanListDTO {
    return this._dto;
  }

  get isInUseByTenant() {
    return this._dto.isInUseByTenant ?? false;
  }

  get currencyUnit() {
    return this._dto.currencyUnit ?? 'KRW';
  }

  get description() {
    return this._dto.description ?? '';
  }

  get featureSet() {
    return this._dto.featureSet ?? '';
  }

  get isBasicPlan() {
    return this._dto.isBasicPlan ?? false;
  }

  get planGrade() {
    return this._dto.planGrade ?? -1;
  }

  get planId() {
    return this._dto.planId;
  }

  get planName() {
    return this._dto.planName ?? '';
  }

  get planType() {
    return this._dto.planType ?? 'ADD_ON';
  }

  get pricingType() {
    return this._dto.pricingType ?? 'CUSTOM';
  }
}
